import accountCampaignPricingEmailSaga from "./account_campaign_pricing_email_saga";
import accountCampaignPricingSmsSaga from "./account_campaign_pricing_sms_saga";
import accountCampaignPricingWhatsappSaga from "./account_campaign_pricing_whatsapp_saga";
import accountListSaga from "./account_list_saga";
import usersSaga from "./account_user_saga";
import walletSaga from "./account_wallet_saga";
import accountCampaignSaga from "./account_campaign_saga";
import accountLoginSessionsSaga from "./account_sessions_saga";
import accountCampaignPricingEmailFinderSaga from "./account_campaign_pricing_email_finder_saga";
import accountCampaignPricingEmailValidationSaga from "./account_campaign_pricing_email_validation_saga";
import accountSettingsSaga from "./account_settings_saga";
import accountRcsBotConfigsSaga from "./account_rcs_bot_configs_saga";
import accountCampaignPricingRCSSaga from "./account_campaign_pricing_rcs_saga";
import campaignSummarySaga from "./account_campaign_summary_saga";

export default [
    accountListSaga, usersSaga, walletSaga, accountCampaignPricingEmailSaga, accountCampaignPricingSmsSaga, accountCampaignSaga,
    accountLoginSessionsSaga, accountCampaignPricingWhatsappSaga, accountCampaignPricingEmailFinderSaga, accountCampaignPricingEmailValidationSaga,
    accountSettingsSaga, accountRcsBotConfigsSaga, accountCampaignPricingRCSSaga, campaignSummarySaga
];
